import { c as _c } from "react/compiler-runtime";
import React, { useState, useCallback } from 'react';
import { Helmet } from 'react-helmet-async';
import PropTypes from 'prop-types';
import ShopByHeaderSection from 'components/consumer/ShopByHeaderSection';
import ToggleButtonGroup from 'components/consumer/ToggleButtonGroup';
import { STYLE_OPTIONS, LEG_STYLE_OPTIONS, CUSHION_STYLE_OPTIONS } from 'commons/constants';
import { GET_COLLECTIONS } from 'mocks/queries';
import ShopByTitleNavigation from 'components/consumer/ShopByTitleNavigation';
import ExpandableModalOptions from 'components/consumer/ExpandableModalOptions';
import ShopByMobileFiltersBar from 'components/consumer/ShopByMobileFiltersBar';
import useSuspenseQuery from 'commons/useSuspenseQuery';
import { COLLECTIONS_PAGE_SEO_DESCRIPTION } from '../../../commons/constants';
import CollectionsGrid from './components/CollectionsGrid';
import { withState } from './withState';
import ShopByMobileFilterBarButton from './components/ShopByMobileFiltersBarButton';
import MobileOnly from '../MobileOnly';
import TabletAndDesktopOnly from '../TabletAndDesktopOnly';
const CollectionPage = t0 => {
  const $ = _c(28);
  const {
    state,
    actions,
    LUXContext: t1
  } = t0;
  const LUXContext = t1 === undefined ? null : t1;
  const [isMobileStyleFiltersOpen, setIsMobileStyleFiltersOpen] = useState(false);
  const [isMobileCushionFiltersOpen, setIsMobileCushionFiltersOpen] = useState(false);
  const [isMobileLegStyleFiltersOpen, setIsMobileLegStyleFiltersOpen] = useState(false);
  const [LUXLoadedSent, updateLUXLoaded] = useState(false);
  let t2;
  if ($[0] !== state.filters) {
    t2 = {
      variables: {
        filters: state.filters
      },
      fetchPolicy: "cache-and-network"
    };
    $[0] = state.filters;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const {
    data,
    error,
    loading
  } = useSuspenseQuery(GET_COLLECTIONS, t2);
  const sendLUXLoaded = () => {
    if (!LUXLoadedSent && LUXContext && LUXContext.isLUXInitSet) {
      LUXContext.updatedLoadedComponents("CollectionsPage");
      updateLUXLoaded(true);
    }
  };
  let t3;
  if ($[2] !== actions || $[3] !== state.filters.cushion_style || $[4] !== state.filters.leg_style || $[5] !== state.filters.style) {
    t3 = () => <><ShopByHeaderSection label="Style"><ToggleButtonGroup items={[{
          label: "All",
          id: "all",
          isSelected: typeof state.filters.style === "undefined",
          onClick: () => {
            actions.clearFilterField("style");
          }
        }, ...STYLE_OPTIONS.map(option => {
          const isSelected = state.filters.style && state.filters.style[option.value];
          return {
            label: option.label,
            id: option.value,
            isSelected,
            onClick: () => {
              actions.onFilterChange("style", option.value);
            }
          };
        })]} /></ShopByHeaderSection><ShopByHeaderSection label="Cushion"><ToggleButtonGroup items={[{
          label: "Any",
          id: "any",
          isSelected: typeof state.filters.cushion_style === "undefined",
          onClick: () => {
            actions.clearFilterField("cushion_style");
          }
        }, ...CUSHION_STYLE_OPTIONS.map(option_0 => {
          const isSelected_0 = state.filters.cushion_style && state.filters.cushion_style[option_0.value];
          return {
            label: option_0.label,
            id: option_0.value,
            isSelected: isSelected_0,
            onClick: () => {
              actions.onFilterChange("cushion_style", option_0.value);
            }
          };
        })]} /></ShopByHeaderSection><ShopByHeaderSection label="Leg Style"><ToggleButtonGroup items={[{
          label: "Any",
          id: "any",
          isSelected: typeof state.filters.leg_style === "undefined",
          onClick: () => {
            actions.clearFilterField("leg_style");
          }
        }, ...LEG_STYLE_OPTIONS.map(option_1 => {
          const isSelected_1 = state.filters.leg_style && state.filters.leg_style[option_1.value];
          return {
            label: option_1.label,
            id: option_1.value,
            isSelected: isSelected_1,
            onClick: () => {
              actions.onFilterChange("leg_style", option_1.value);
            }
          };
        })]} /></ShopByHeaderSection></>;
    $[2] = actions;
    $[3] = state.filters.cushion_style;
    $[4] = state.filters.leg_style;
    $[5] = state.filters.style;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const AllFilters = t3;
  let t4;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {};
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let filtersConfig = t4;
  let t5;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = [];
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let finalCollections = t5;
  if (!error && !loading && data.getCollections && data.getCollections.collections.length) {
    if (!LUXLoadedSent) {
      sendLUXLoaded();
    }
    filtersConfig = data.getCollections.filtersConfig;
    let t6;
    if ($[9] !== actions || $[10] !== data.getCollections.collections) {
      t6 = actions.addMainImages(data.getCollections.collections);
      $[9] = actions;
      $[10] = data.getCollections.collections;
      $[11] = t6;
    } else {
      t6 = $[11];
    }
    finalCollections = t6;
  }
  let t6;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <Helmet><title>Collection Pages | Joybird</title><meta name="keywords" content="Collection Page" /><meta name="description" content={COLLECTIONS_PAGE_SEO_DESCRIPTION} /><meta property="og:title" content="Collection Pages | Joybird" /><meta property="og:description" content={COLLECTIONS_PAGE_SEO_DESCRIPTION} /><meta property="og:type" content="website" /></Helmet>;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <ShopByTitleNavigation page="Collection" />;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== AllFilters || $[15] !== actions || $[16] !== error || $[17] !== filtersConfig || $[18] !== finalCollections || $[19] !== isMobileCushionFiltersOpen || $[20] !== isMobileLegStyleFiltersOpen || $[21] !== isMobileStyleFiltersOpen || $[22] !== loading || $[23] !== state.filters || $[24] !== state.selectedCollection) {
    t8 = !error && <><div className="flex border-b-[1px] border-b-gray-light7 flex-wrap md:pt-4 md:px-[3.333vw] px-12"><MobileOnly><ShopByMobileFiltersBar variant="collections-page"><ShopByMobileFilterBarButton isOpen={isMobileStyleFiltersOpen} onClick={() => {
              setIsMobileStyleFiltersOpen(!isMobileStyleFiltersOpen);
            }}><span className="h-full">{typeof state.filters.style === "undefined" ? "All Styles" : STYLE_OPTIONS.find(option_2 => !!state.filters.style && !!state.filters.style[option_2.value]).label}</span></ShopByMobileFilterBarButton><ShopByMobileFilterBarButton isOpen={isMobileCushionFiltersOpen} onClick={() => {
              setIsMobileCushionFiltersOpen(!isMobileCushionFiltersOpen);
            }}><span className="h-full">{typeof state.filters.cushion_style === "undefined" ? "Cushion" : CUSHION_STYLE_OPTIONS.find(option_3 => !!state.filters.cushion_style && !!state.filters.cushion_style[option_3.value]).label}</span></ShopByMobileFilterBarButton><ShopByMobileFilterBarButton isOpen={isMobileLegStyleFiltersOpen} onClick={() => {
              setIsMobileLegStyleFiltersOpen(!isMobileLegStyleFiltersOpen);
            }}><span className="h-full">{typeof state.filters.leg_style === "undefined" ? "Leg Style" : LEG_STYLE_OPTIONS.find(option_4 => !!state.filters.leg_style && !!state.filters.leg_style[option_4.value]).label}</span></ShopByMobileFilterBarButton></ShopByMobileFiltersBar></MobileOnly><TabletAndDesktopOnly><div className="max-[767px]:hidden flex flex-wrap"><AllFilters loading={loading} filtersConfig={filtersConfig} /></div></TabletAndDesktopOnly></div><div className="relative"><CollectionsGrid loading={loading} collections={finalCollections} selectedCollection={state.selectedCollection} clearFilters={async () => {
          await actions.clearFilterField("style");
          await actions.clearFilterField("cushion_style");
          await actions.clearFilterField("leg_style");
        }} filters={state.filters} /><MobileOnly><ExpandableModalOptions isOpen={isMobileStyleFiltersOpen} onClose={() => {
            setIsMobileStyleFiltersOpen(false);
          }} label="Styles" options={[{
            label: "All",
            id: "all",
            isSelected: typeof state.filters.style === "undefined",
            onClick: () => {
              actions.clearFilterField("style");
              setIsMobileStyleFiltersOpen(false);
            }
          }, ...STYLE_OPTIONS.map(option_5 => {
            const isSelected_2 = state.filters.style && state.filters.style[option_5.value];
            return {
              label: option_5.label,
              id: option_5.value,
              isSelected: isSelected_2,
              onClick: () => {
                actions.onFilterChange("style", option_5.value);
                setIsMobileStyleFiltersOpen(false);
              }
            };
          })]} /><ExpandableModalOptions isOpen={isMobileCushionFiltersOpen} onClose={() => {
            setIsMobileCushionFiltersOpen(false);
          }} label="Cushion" options={[{
            label: "Any",
            id: "any",
            isSelected: typeof state.filters.cushion_style === "undefined",
            onClick: () => {
              actions.clearFilterField("cushion_style");
              setIsMobileCushionFiltersOpen(false);
            }
          }, ...CUSHION_STYLE_OPTIONS.map(option_6 => {
            const isSelected_3 = state.filters.cushion_style && state.filters.cushion_style[option_6.value];
            return {
              label: option_6.label,
              id: option_6.value,
              isSelected: isSelected_3,
              onClick: () => {
                actions.onFilterChange("cushion_style", option_6.value);
                setIsMobileCushionFiltersOpen(false);
              }
            };
          })]} /><ExpandableModalOptions isOpen={isMobileLegStyleFiltersOpen} onClose={() => {
            setIsMobileLegStyleFiltersOpen(false);
          }} label="Leg Style" options={[{
            label: "All",
            id: "all",
            isSelected: typeof state.filters.leg_style === "undefined",
            onClick: () => {
              actions.clearFilterField("leg_style");
              setIsMobileLegStyleFiltersOpen(false);
            }
          }, ...LEG_STYLE_OPTIONS.map(option_7 => {
            const isSelected_4 = state.filters.leg_style && state.filters.leg_style[option_7.value];
            return {
              label: option_7.label,
              id: option_7.value,
              isSelected: isSelected_4,
              onClick: () => {
                actions.onFilterChange("leg_style", option_7.value);
                setIsMobileLegStyleFiltersOpen(false);
              }
            };
          })]} /></MobileOnly></div></>;
    $[14] = AllFilters;
    $[15] = actions;
    $[16] = error;
    $[17] = filtersConfig;
    $[18] = finalCollections;
    $[19] = isMobileCushionFiltersOpen;
    $[20] = isMobileLegStyleFiltersOpen;
    $[21] = isMobileStyleFiltersOpen;
    $[22] = loading;
    $[23] = state.filters;
    $[24] = state.selectedCollection;
    $[25] = t8;
  } else {
    t8 = $[25];
  }
  let t9;
  if ($[26] !== t8) {
    t9 = <>{t6}<div className="flex relative flex-col lg:block">{t7}{t8}</div></>;
    $[26] = t8;
    $[27] = t9;
  } else {
    t9 = $[27];
  }
  return t9;
};
CollectionPage.propTypes = {
  actions: PropTypes.shape({
    clearFilterField: PropTypes.func,
    onFilterChange: PropTypes.func,
    addMainImages: PropTypes.func
  }).isRequired,
  LUXContext: PropTypes.shape({
    isLUXInitSet: PropTypes.bool
  }),
  state: PropTypes.shape({
    filters: PropTypes.shape({
      cushion_style: PropTypes.shape({}),
      leg_style: PropTypes.shape({}),
      style: PropTypes.shape({})
    }),
    selectedCollection: PropTypes.shape({})
  }).isRequired
};
export default withState(CollectionPage);